import { z } from 'zod';
import { estado, opcional, uuid } from './comunes.js';
/**
 * LOG-FT-09 — Aprobación de Pagos de Bienes o Servicios.
 *
 * El caso real de la plantilla liquida una orden en 6 armadas, así que la
 * relación orden → pagos es 1:N. La base impide que la suma exceda el total de
 * la orden y exige que ambos estén en la misma moneda.
 */
export const pagoItemEntrada = z.object({
    itemNumero: z.number().int().min(1).max(999),
    ordenItemId: opcional(z.number().int().positive()),
    descripcion: z.string().trim().min(3, 'Describa el bien o servicio').max(2000),
    cantidadSolicitada: z.number().positive('La cantidad debe ser mayor a cero').max(99_999_999),
    cantidadRecibida: z.number().min(0).max(99_999_999).default(0),
    conforme: z.boolean().default(false),
});
export const pagoEntrada = z
    .object({
    empresaId: z.number().int().positive('Elija la empresa emisora'),
    correlativo: z.number().int().min(1, 'El correlativo debe ser mayor a cero').max(999_999),
    ordenId: uuid,
    fechaEmision: z.iso.date(),
    numeroFactura: opcional(z.string().trim().max(30)),
    fechaFactura: opcional(z.iso.date()),
    componente: opcional(z.string().trim().max(150)),
    actividad: opcional(z.string().trim().max(300)),
    numeroArmada: z.number().int().min(1, 'La armada debe ser 1 o mayor').max(99).default(1),
    totalArmadas: opcional(z.number().int().min(1).max(99)),
    monto: z.number().positive('El monto debe ser mayor a cero').max(99_999_999),
    observaciones: opcional(z.string().trim().max(2000)),
    items: z.array(pagoItemEntrada).min(1, 'Agregue al menos un ítem').max(200),
})
    .refine((v) => v.totalArmadas == null || v.numeroArmada <= v.totalArmadas, {
    path: ['numeroArmada'],
    message: 'La armada no puede ser mayor que el total de armadas',
})
    .refine((v) => v.items.every((i) => i.cantidadRecibida <= i.cantidadSolicitada), {
    path: ['items'],
    message: 'La cantidad recibida no puede superar la solicitada',
});
export const pagoEdicion = z.object({
    empresaId: z.number().int().positive().optional(),
    correlativo: z.number().int().min(1).max(999_999).optional(),
    fechaEmision: z.iso.date().optional(),
    numeroFactura: opcional(z.string().trim().max(30)),
    fechaFactura: opcional(z.iso.date()),
    componente: opcional(z.string().trim().max(150)),
    actividad: opcional(z.string().trim().max(300)),
    numeroArmada: z.number().int().min(1).max(99).optional(),
    totalArmadas: opcional(z.number().int().min(1).max(99)),
    monto: z.number().positive().max(99_999_999).optional(),
    observaciones: opcional(z.string().trim().max(2000)),
    items: z.array(pagoItemEntrada).min(1).max(200).optional(),
});
export const pagoItem = z.object({
    id: z.number().int(),
    itemNumero: z.number().int(),
    ordenItemId: z.number().int().nullable(),
    descripcion: z.string(),
    cantidadSolicitada: z.number(),
    cantidadRecibida: z.number(),
    conforme: z.boolean(),
});
export const pagoResumen = z.object({
    id: uuid,
    numero: z.string(),
    estado,
    fechaEmision: z.string(),
    empresa: z.string(),
    ordenId: uuid,
    ordenNumero: z.string(),
    proveedor: z.string(),
    numeroFactura: z.string().nullable(),
    numeroArmada: z.number().int(),
    totalArmadas: z.number().int().nullable(),
    moneda: z.string(),
    monto: z.number(),
});
export const pago = pagoResumen.extend({
    empresaId: z.number().int(),
    correlativo: z.number().int(),
    proveedorId: uuid,
    fechaFactura: z.string().nullable(),
    componente: z.string().nullable(),
    actividad: z.string().nullable(),
    monedaId: z.number().int(),
    tipoCambio: z.number().nullable(),
    observaciones: z.string().nullable(),
    /** Contexto de la orden, para decidir sin salir de la pantalla. */
    ordenTotal: z.number(),
    ordenPagado: z.number(),
    ordenSaldo: z.number(),
    items: z.array(pagoItem),
});
/** Saldo disponible de una orden, para proponer el monto de la siguiente armada. */
export const saldoOrden = z.object({
    ordenId: uuid,
    ordenNumero: z.string(),
    moneda: z.string(),
    total: z.number(),
    pagado: z.number(),
    saldo: z.number(),
    armadasEmitidas: z.number().int(),
});
//# sourceMappingURL=pago.js.map